import spell0 from '../../data/spells/abi-dalzims-horrid-wilting.json';
import spell1 from '../../data/spells/absorb-elements.json';
import spell2 from '../../data/spells/acid-splash.json';
import spell3 from '../../data/spells/acid-stream.json';
import spell4 from '../../data/spells/aganazzars-scorcher.json';
import spell5 from '../../data/spells/aid.json';
import spell6 from '../../data/spells/air-bubble.json';
import spell7 from '../../data/spells/alarm.json';
import spell8 from '../../data/spells/alter-self.json';
import spell9 from '../../data/spells/animal-friendship.json';
import spell10 from '../../data/spells/animal-messenger.json';
import spell11 from '../../data/spells/animal-shapes.json';
import spell12 from '../../data/spells/animate-dead.json';
import spell13 from '../../data/spells/animate-objects.json';
import spell15 from '../../data/spells/antagonize.json';
import spell14 from '../../data/spells/antagonize-ua.json';
import spell16 from '../../data/spells/antilife-shell.json';
import spell17 from '../../data/spells/antimagic-field.json';
import spell18 from '../../data/spells/antipathy-sympathy.json';
import spell19 from '../../data/spells/arcane-eye.json';
import spell20 from '../../data/spells/arcane-gate.json';
import spell21 from '../../data/spells/arcane-hacking.json';
import spell22 from '../../data/spells/arcane-lock.json';
import spell23 from '../../data/spells/arcane-weapon.json';
import spell24 from '../../data/spells/armor-of-agathys.json';
import spell25 from '../../data/spells/arms-of-hadar.json';
import spell26 from '../../data/spells/ashardalons-stride.json';
import spell27 from '../../data/spells/astral-projection.json';
import spell28 from '../../data/spells/augury.json';
import spell29 from '../../data/spells/aura-of-life.json';
import spell30 from '../../data/spells/aura-of-purity.json';
import spell31 from '../../data/spells/aura-of-vitality.json';
import spell32 from '../../data/spells/awaken.json';
import spell33 from '../../data/spells/bane.json';
import spell34 from '../../data/spells/banishing-smite.json';
import spell35 from '../../data/spells/banishment.json';
import spell36 from '../../data/spells/barkskin.json';
import spell37 from '../../data/spells/beacon-of-hope.json';
import spell38 from '../../data/spells/beast-bond.json';
import spell39 from '../../data/spells/beast-sense.json';
import spell40 from '../../data/spells/bestow-curse.json';
import spell41 from '../../data/spells/bigbys-hand.json';
import spell42 from '../../data/spells/blade-barrier.json';
import spell43 from '../../data/spells/blade-of-disaster.json';
import spell44 from '../../data/spells/blade-ward.json';
import spell45 from '../../data/spells/bless.json';
import spell46 from '../../data/spells/blight.json';
import spell47 from '../../data/spells/blinding-smite.json';
import spell48 from '../../data/spells/blindness-deafness.json';
import spell49 from '../../data/spells/blink.json';
import spell50 from '../../data/spells/blur.json';
import spell51 from '../../data/spells/bones-of-the-earth.json';
import spell52 from '../../data/spells/booming-blade.json';
import spell53 from '../../data/spells/borrowed-knowledge.json';
import spell54 from '../../data/spells/branding-smite.json';
import spell55 from '../../data/spells/burning-hands.json';
import spell56 from '../../data/spells/call-lightning.json';
import spell57 from '../../data/spells/calm-emotions.json';
import spell58 from '../../data/spells/catapult.json';
import spell59 from '../../data/spells/catnap.json';
import spell60 from '../../data/spells/cause-fear.json';
import spell61 from '../../data/spells/ceremony.json';
import spell62 from '../../data/spells/chain-lightning.json';
import spell63 from '../../data/spells/chaos-bolt.json';
import spell64 from '../../data/spells/charm-monster.json';
import spell65 from '../../data/spells/charm-person.json';
import spell66 from '../../data/spells/chill-touch.json';
import spell67 from '../../data/spells/chromatic-orb.json';
import spell68 from '../../data/spells/circle-of-death.json';
import spell69 from '../../data/spells/circle-of-power.json';
import spell70 from '../../data/spells/clairvoyance.json';
import spell71 from '../../data/spells/clone.json';
import spell72 from '../../data/spells/cloud-of-daggers.json';
import spell73 from '../../data/spells/cloudkill.json';
import spell74 from '../../data/spells/color-spray.json';
import spell75 from '../../data/spells/command.json';
import spell78 from '../../data/spells/commune.json';
import spell76 from '../../data/spells/commune-with-city.json';
import spell77 from '../../data/spells/commune-with-nature.json';
import spell79 from '../../data/spells/compelled-duel.json';
import spell80 from '../../data/spells/comprehend-languages.json';
import spell81 from '../../data/spells/compulsion.json';
import spell82 from '../../data/spells/cone-of-cold.json';
import spell83 from '../../data/spells/confusion.json';
import spell84 from '../../data/spells/conjure-animals.json';
import spell85 from '../../data/spells/conjure-barlgura.json';
import spell86 from '../../data/spells/conjure-barrage.json';
import spell87 from '../../data/spells/conjure-celestial.json';
import spell88 from '../../data/spells/conjure-elemental.json';
import spell89 from '../../data/spells/conjure-fey.json';
import spell90 from '../../data/spells/conjure-hezrou.json';
import spell91 from '../../data/spells/conjure-knowbot.json';
import spell92 from '../../data/spells/conjure-lesser-demon.json';
import spell93 from '../../data/spells/conjure-minor-elementals.json';
import spell94 from '../../data/spells/conjure-shadow-demon.json';
import spell95 from '../../data/spells/conjure-volley.json';
import spell96 from '../../data/spells/conjure-vrock.json';
import spell97 from '../../data/spells/conjure-woodland-beings.json';
import spell98 from '../../data/spells/contact-other-plane.json';
import spell99 from '../../data/spells/contagion.json';
import spell100 from '../../data/spells/contingency.json';
import spell101 from '../../data/spells/continual-flame.json';
import spell102 from '../../data/spells/control-flames.json';
import spell103 from '../../data/spells/control-water.json';
import spell104 from '../../data/spells/control-weather.json';
import spell105 from '../../data/spells/control-winds.json';
import spell106 from '../../data/spells/cordon-of-arrows.json';
import spell107 from '../../data/spells/counterspell.json';
import spell108 from '../../data/spells/create-bonfire.json';
import spell109 from '../../data/spells/create-food-and-water.json';
import spell110 from '../../data/spells/create-homunculus.json';
import spell111 from '../../data/spells/create-magen.json';
import spell112 from '../../data/spells/create-or-destroy-water.json';
import spell113 from '../../data/spells/create-spelljamming-helm.json';
import spell114 from '../../data/spells/create-undead.json';
import spell115 from '../../data/spells/creation.json';
import spell116 from '../../data/spells/crown-of-madness.json';
import spell117 from '../../data/spells/crown-of-stars.json';
import spell118 from '../../data/spells/crusaders-mantle.json';
import spell119 from '../../data/spells/cure-wounds.json';
import spell120 from '../../data/spells/dancing-lights.json';
import spell121 from '../../data/spells/danse-macabre.json';
import spell122 from '../../data/spells/dark-star.json';
import spell123 from '../../data/spells/darkness.json';
import spell124 from '../../data/spells/darkvision.json';
import spell125 from '../../data/spells/dawn.json';
import spell126 from '../../data/spells/daylight.json';
import spell127 from '../../data/spells/death-ward.json';
import spell128 from '../../data/spells/decompose.json';
import spell129 from '../../data/spells/delayed-blast-fireball.json';
import spell130 from '../../data/spells/demiplane.json';
import spell131 from '../../data/spells/destructive-wave.json';
import spell132 from '../../data/spells/detect-evil-and-good.json';
import spell133 from '../../data/spells/detect-magic.json';
import spell134 from '../../data/spells/detect-poison-and-disease.json';
import spell135 from '../../data/spells/detect-thoughts.json';
import spell136 from '../../data/spells/digital-phantom.json';
import spell137 from '../../data/spells/dimension-door.json';
import spell138 from '../../data/spells/disguise-self.json';
import spell139 from '../../data/spells/disintegrate.json';
import spell140 from '../../data/spells/dispel-evil-and-good.json';
import spell141 from '../../data/spells/dispel-magic.json';
import spell142 from '../../data/spells/dissonant-whispers.json';
import spell143 from '../../data/spells/distort-value.json';
import spell144 from '../../data/spells/divination.json';
import spell145 from '../../data/spells/divine-favor.json';
import spell146 from '../../data/spells/divine-word.json';
import spell147 from '../../data/spells/dominate-beast.json';
import spell148 from '../../data/spells/dominate-monster.json';
import spell149 from '../../data/spells/dominate-person.json';
import spell151 from '../../data/spells/draconic-transformation.json';
import spell150 from '../../data/spells/draconic-transformation-ua.json';
import spell152 from '../../data/spells/dragons-breath.json';
import spell153 from '../../data/spells/drawmijs-instant-summons.json';
import spell155 from '../../data/spells/dream.json';
import spell154 from '../../data/spells/dream-of-the-blue-veil.json';
import spell156 from '../../data/spells/druid-grove.json';
import spell157 from '../../data/spells/druidcraft.json';
import spell158 from '../../data/spells/dust-devil.json';
import spell159 from '../../data/spells/earth-tremor.json';
import spell160 from '../../data/spells/earthbind.json';
import spell161 from '../../data/spells/earthquake.json';
import spell162 from '../../data/spells/ego-whip.json';
import spell163 from '../../data/spells/eldritch-blast.json';
import spell164 from '../../data/spells/elemental-bane.json';
import spell165 from '../../data/spells/elemental-weapon.json';
import spell166 from '../../data/spells/encode-thoughts.json';
import spell167 from '../../data/spells/enemies-abound.json';
import spell168 from '../../data/spells/enervation.json';
import spell169 from '../../data/spells/enhance-ability.json';
import spell170 from '../../data/spells/enlarge-reduce.json';
import spell171 from '../../data/spells/ensnaring-strike.json';
import spell172 from '../../data/spells/entangle.json';
import spell173 from '../../data/spells/enthrall.json';
import spell174 from '../../data/spells/erupting-earth.json';
import spell175 from '../../data/spells/etherealness.json';
import spell176 from '../../data/spells/evards-black-tentacles.json';
import spell177 from '../../data/spells/expeditious-retreat.json';
import spell178 from '../../data/spells/eyebite.json';
import spell179 from '../../data/spells/fabricate.json';
import spell180 from '../../data/spells/faerie-fire.json';
import spell181 from '../../data/spells/false-life.json';
import spell182 from '../../data/spells/far-step.json';
import spell183 from '../../data/spells/fast-friends.json';
import spell184 from '../../data/spells/fear.json';
import spell185 from '../../data/spells/feather-fall.json';
import spell186 from '../../data/spells/feeblemind.json';
import spell187 from '../../data/spells/feign-death.json';
import spell188 from '../../data/spells/find-familiar.json';
import spell189 from '../../data/spells/find-greater-steed.json';
import spell190 from '../../data/spells/find-steed.json';
import spell191 from '../../data/spells/find-the-path.json';
import spell192 from '../../data/spells/find-traps.json';
import spell193 from '../../data/spells/find-vehicle.json';
import spell194 from '../../data/spells/finger-of-death.json';
import spell195 from '../../data/spells/fire-bolt.json';
import spell196 from '../../data/spells/fire-shield.json';
import spell197 from '../../data/spells/fire-storm.json';
import spell198 from '../../data/spells/fireball.json';
import spell199 from '../../data/spells/fizban-s-platinum-shield-ua.json';
import spell200 from '../../data/spells/fizbans-platinum-shield.json';
import spell201 from '../../data/spells/flame-arrows.json';
import spell202 from '../../data/spells/flame-blade.json';
import spell203 from '../../data/spells/flame-stride.json';
import spell204 from '../../data/spells/flame-strike.json';
import spell205 from '../../data/spells/flaming-sphere.json';
import spell206 from '../../data/spells/flesh-to-stone.json';
import spell207 from '../../data/spells/flock-of-familiars.json';
import spell208 from '../../data/spells/fly.json';
import spell209 from '../../data/spells/fog-cloud.json';
import spell210 from '../../data/spells/forbiddance.json';
import spell211 from '../../data/spells/forcecage.json';
import spell212 from '../../data/spells/foresight.json';
import spell213 from '../../data/spells/fortunes-favor.json';
import spell214 from '../../data/spells/freedom-of-movement.json';
import spell215 from '../../data/spells/freedom-of-the-waves.json';
import spell216 from '../../data/spells/freedom-of-the-winds.json';
import spell217 from '../../data/spells/friends.json';
import spell218 from '../../data/spells/frost-fingers.json';
import spell219 from '../../data/spells/frostbite.json';
import spell220 from '../../data/spells/galders-speedy-courier.json';
import spell221 from '../../data/spells/galders-tower.json';
import spell222 from '../../data/spells/gaseous-form.json';
import spell224 from '../../data/spells/gate.json';
import spell223 from '../../data/spells/gate-seal.json';
import spell225 from '../../data/spells/geas.json';
import spell226 from '../../data/spells/gentle-repose.json';
import spell227 from '../../data/spells/giant-insect.json';
import spell228 from '../../data/spells/gift-of-alacrity.json';
import spell229 from '../../data/spells/gift-of-gab.json';
import spell230 from '../../data/spells/glibness.json';
import spell231 from '../../data/spells/globe-of-invulnerability.json';
import spell232 from '../../data/spells/glyph-of-warding.json';
import spell233 from '../../data/spells/goodberry.json';
import spell234 from '../../data/spells/grasping-vine.json';
import spell235 from '../../data/spells/gravity-fissure.json';
import spell236 from '../../data/spells/gravity-sinkhole.json';
import spell237 from '../../data/spells/grease.json';
import spell238 from '../../data/spells/greater-invisibility.json';
import spell239 from '../../data/spells/greater-restoration.json';
import spell240 from '../../data/spells/green-flame-blade.json';
import spell241 from '../../data/spells/guardian-of-faith.json';
import spell242 from '../../data/spells/guardian-of-nature.json';
import spell243 from '../../data/spells/guards-and-wards.json';
import spell244 from '../../data/spells/guidance.json';
import spell245 from '../../data/spells/guiding-bolt.json';
import spell246 from '../../data/spells/guiding-hand-ua.json';
import spell248 from '../../data/spells/gust.json';
import spell247 from '../../data/spells/gust-of-wind.json';
import spell249 from '../../data/spells/hail-of-thorns.json';
import spell250 from '../../data/spells/hallow.json';
import spell251 from '../../data/spells/hallucinatory-terrain.json';
import spell252 from '../../data/spells/hand-of-radiance.json';
import spell253 from '../../data/spells/harm.json';
import spell254 from '../../data/spells/haste.json';
import spell255 from '../../data/spells/haywire.json';
import spell256 from '../../data/spells/heal.json';
import spell257 from '../../data/spells/healing-elixir-ua.json';
import spell258 from '../../data/spells/healing-spirit.json';
import spell259 from '../../data/spells/healing-word.json';
import spell260 from '../../data/spells/heat-metal.json';
import spell261 from '../../data/spells/hellish-rebuke.json';
import spell262 from '../../data/spells/heroes-feast.json';
import spell263 from '../../data/spells/heroism.json';
import spell264 from '../../data/spells/hex.json';
import spell265 from '../../data/spells/hold-monster.json';
import spell266 from '../../data/spells/hold-person.json';
import spell267 from '../../data/spells/holy-aura.json';
import spell268 from '../../data/spells/holy-weapon.json';
import spell269 from '../../data/spells/house-of-cards-ua.json';
import spell270 from '../../data/spells/hunger-of-hadar.json';
import spell271 from '../../data/spells/hunters-mark.json';
import spell272 from '../../data/spells/hypnotic-pattern.json';
import spell273 from '../../data/spells/ice-knife.json';
import spell274 from '../../data/spells/ice-storm.json';
import spell275 from '../../data/spells/icingdeath-s-frost.json';
import spell276 from '../../data/spells/id-insinuation.json';
import spell277 from '../../data/spells/identify.json';
import spell278 from '../../data/spells/illusory-dragon.json';
import spell279 from '../../data/spells/illusory-script.json';
import spell280 from '../../data/spells/immolation.json';
import spell281 from '../../data/spells/immovable-object.json';
import spell282 from '../../data/spells/imprisonment.json';
import spell283 from '../../data/spells/incendiary-cloud.json';
import spell284 from '../../data/spells/incite-greed.json';
import spell285 from '../../data/spells/infallible-relay.json';
import spell286 from '../../data/spells/infernal-calling.json';
import spell287 from '../../data/spells/infestation.json';
import spell288 from '../../data/spells/inflict-wounds.json';
import spell289 from '../../data/spells/insect-plague.json';
import spell290 from '../../data/spells/intellect-fortress.json';
import spell291 from '../../data/spells/investiture-of-flame.json';
import spell292 from '../../data/spells/investiture-of-ice.json';
import spell293 from '../../data/spells/investiture-of-stone.json';
import spell294 from '../../data/spells/investiture-of-wind.json';
import spell296 from '../../data/spells/invisibility.json';
import spell295 from '../../data/spells/invisibility-to-cameras.json';
import spell297 from '../../data/spells/invulnerability.json';
import spell298 from '../../data/spells/jims-glowing-coin.json';
import spell299 from '../../data/spells/jims-magic-missile.json';
import spell300 from '../../data/spells/jump.json';
import spell301 from '../../data/spells/kinetic-jaunt.json';
import spell302 from '../../data/spells/knock.json';
import spell303 from '../../data/spells/legend-lore.json';
import spell304 from '../../data/spells/leomunds-secret-chest.json';
import spell305 from '../../data/spells/leomunds-tiny-hut.json';
import spell306 from '../../data/spells/lesser-restoration.json';
import spell307 from '../../data/spells/levitate.json';
import spell308 from '../../data/spells/life-transference.json';
import spell309 from '../../data/spells/light.json';
import spell310 from '../../data/spells/lightning-arrow.json';
import spell311 from '../../data/spells/lightning-bolt.json';
import spell312 from '../../data/spells/lightning-lure.json';
import spell313 from '../../data/spells/locate-animals-or-plants.json';
import spell314 from '../../data/spells/locate-creature.json';
import spell315 from '../../data/spells/locate-object.json';
import spell316 from '../../data/spells/longstrider.json';
import spell317 from '../../data/spells/maddening-darkness.json';
import spell318 from '../../data/spells/maelstrom.json';
import spell319 from '../../data/spells/mage-armor.json';
import spell321 from '../../data/spells/mage-hand.json';
import spell320 from '../../data/spells/mage-hand-legerdomain.json';
import spell322 from '../../data/spells/magic-circle.json';
import spell323 from '../../data/spells/magic-jar.json';
import spell324 from '../../data/spells/magic-missile.json';
import spell325 from '../../data/spells/magic-mouth.json';
import spell326 from '../../data/spells/magic-stone.json';
import spell327 from '../../data/spells/magic-weapon.json';
import spell328 from '../../data/spells/magnify-gravity.json';
import spell329 from '../../data/spells/major-image.json';
import spell330 from '../../data/spells/mass-cure-wounds.json';
import spell331 from '../../data/spells/mass-heal.json';
import spell332 from '../../data/spells/mass-healing-word.json';
import spell333 from '../../data/spells/mass-polymorph.json';
import spell334 from '../../data/spells/mass-suggestion.json';
import spell335 from '../../data/spells/maximillians-earthen-grasp.json';
import spell336 from '../../data/spells/maze.json';
import spell337 from '../../data/spells/meld-into-stone.json';
import spell338 from '../../data/spells/melfs-acid-arrow.json';
import spell339 from '../../data/spells/melfs-minute-meteors.json';
import spell340 from '../../data/spells/mending.json';
import spell341 from '../../data/spells/mental-barrier.json';
import spell342 from '../../data/spells/mental-prison.json';
import spell343 from '../../data/spells/message.json';
import spell344 from '../../data/spells/meteor-swarm.json';
import spell345 from '../../data/spells/mighty-fortress.json';
import spell346 from '../../data/spells/mind-blank.json';
import spell347 from '../../data/spells/mind-sliver.json';
import spell348 from '../../data/spells/mind-spike.json';
import spell349 from '../../data/spells/mind-thrust.json';
import spell350 from '../../data/spells/minor-illusion.json';
import spell351 from '../../data/spells/mirage-arcane.json';
import spell352 from '../../data/spells/mirror-image.json';
import spell353 from '../../data/spells/mislead.json';
import spell354 from '../../data/spells/misty-step.json';
import spell355 from '../../data/spells/modify-memory.json';
import spell356 from '../../data/spells/mold-earth.json';
import spell357 from '../../data/spells/moonbeam.json';
import spell358 from '../../data/spells/mordenkainens-faithful-hound.json';
import spell359 from '../../data/spells/mordenkainens-magnificent-mansion.json';
import spell360 from '../../data/spells/mordenkainens-private-sanctum.json';
import spell361 from '../../data/spells/mordenkainens-sword.json';
import spell362 from '../../data/spells/motivational-speech.json';
import spell363 from '../../data/spells/move-earth.json';
import spell365 from '../../data/spells/nathairs-mischief.json';
import spell364 from '../../data/spells/nathairs-mischief-ua.json';
import spell366 from '../../data/spells/negative-energy-flood.json';
import spell367 from '../../data/spells/nondetection.json';
import spell368 from '../../data/spells/nystuls-magic-aura.json';
import spell369 from '../../data/spells/on-off.json';
import spell370 from '../../data/spells/otherworldly-form.json';
import spell371 from '../../data/spells/otilukes-freezing-sphere.json';
import spell372 from '../../data/spells/otilukes-resilient-sphere.json';
import spell373 from '../../data/spells/ottos-irresistible-dance.json';
import spell374 from '../../data/spells/pass-without-trace.json';
import spell375 from '../../data/spells/passwall.json';
import spell376 from '../../data/spells/phantasmal-force.json';
import spell377 from '../../data/spells/phantasmal-killer.json';
import spell378 from '../../data/spells/phantom-steed.json';
import spell379 from '../../data/spells/planar-ally.json';
import spell380 from '../../data/spells/planar-binding.json';
import spell381 from '../../data/spells/plane-shift.json';
import spell382 from '../../data/spells/plant-growth.json';
import spell383 from '../../data/spells/poison-spray.json';
import spell384 from '../../data/spells/polymorph.json';
import spell385 from '../../data/spells/power-word-heal.json';
import spell386 from '../../data/spells/power-word-kill.json';
import spell387 from '../../data/spells/power-word-pain.json';
import spell388 from '../../data/spells/power-word-stun.json';
import spell389 from '../../data/spells/prayer-of-healing.json';
import spell390 from '../../data/spells/prestidigitation.json';
import spell391 from '../../data/spells/primal-savagery.json';
import spell392 from '../../data/spells/primordial-ward.json';
import spell393 from '../../data/spells/prismatic-spray.json';
import spell394 from '../../data/spells/prismatic-wall.json';
import spell395 from '../../data/spells/produce-flame.json';
import spell396 from '../../data/spells/programmed-illusion.json';
import spell397 from '../../data/spells/project-image.json';
import spell398 from '../../data/spells/protection-from-ballistics.json';
import spell399 from '../../data/spells/protection-from-energy.json';
import spell400 from '../../data/spells/protection-from-evil-and-good.json';
import spell401 from '../../data/spells/protection-from-poison.json';
import spell402 from '../../data/spells/psionic-blast.json';
import spell403 from '../../data/spells/psychic-crush.json';
import spell404 from '../../data/spells/psychic-scream.json';
import spell405 from '../../data/spells/pulse-wave.json';
import spell406 from '../../data/spells/puppet.json';
import spell407 from '../../data/spells/purify-food-and-drink.json';
import spell408 from '../../data/spells/pyrotechnics.json';
import spell409 from '../../data/spells/raise-dead.json';
import spell410 from '../../data/spells/rarys-telepathic-bond.json';
import spell412 from '../../data/spells/raulothims-psychic-lance.json';
import spell411 from '../../data/spells/raulothims-psychic-lance-ua.json';
import spell413 from '../../data/spells/ravenous-void.json';
import spell414 from '../../data/spells/ray-of-enfeeblement.json';
import spell415 from '../../data/spells/ray-of-frost.json';
import spell416 from '../../data/spells/ray-of-sickness.json';
import spell417 from '../../data/spells/reality-break.json';
import spell418 from '../../data/spells/regenerate.json';
import spell419 from '../../data/spells/reincarnate.json';
import spell420 from '../../data/spells/remote-access.json';
import spell421 from '../../data/spells/remove-curse.json';
import spell422 from '../../data/spells/resistance.json';
import spell423 from '../../data/spells/resurrection.json';
import spell424 from '../../data/spells/reverse-gravity.json';
import spell425 from '../../data/spells/revivify.json';
import spell426 from '../../data/spells/rimes-binding-ice.json';
import spell427 from '../../data/spells/rope-trick.json';
import spell428 from '../../data/spells/sacred-flame.json';
import spell429 from '../../data/spells/sanctuary.json';
import spell430 from '../../data/spells/sapping-sting.json';
import spell431 from '../../data/spells/scatter.json';
import spell432 from '../../data/spells/scorching-ray.json';
import spell433 from '../../data/spells/scrying.json';
import spell434 from '../../data/spells/searing-smite.json';
import spell435 from '../../data/spells/see-invisibility.json';
import spell436 from '../../data/spells/seeming.json';
import spell437 from '../../data/spells/sending.json';
import spell438 from '../../data/spells/sense-emotion.json';
import spell439 from '../../data/spells/sequester.json';
import spell440 from '../../data/spells/shadow-blade.json';
import spell441 from '../../data/spells/shadow-of-moil.json';
import spell442 from '../../data/spells/shape-water.json';
import spell443 from '../../data/spells/shapechange.json';
import spell444 from '../../data/spells/shatter.json';
import spell446 from '../../data/spells/shield.json';
import spell445 from '../../data/spells/shield-of-faith.json';
import spell447 from '../../data/spells/shillelagh.json';
import spell448 from '../../data/spells/shocking-grasp.json';
import spell449 from '../../data/spells/shutdown.json';
import spell450 from '../../data/spells/sickening-radiance.json';
import spell451 from '../../data/spells/silence.json';
import spell452 from '../../data/spells/silent-image.json';
import spell453 from '../../data/spells/silvery-barbs.json';
import spell454 from '../../data/spells/simulacrum.json';
import spell455 from '../../data/spells/skill-empowerment.json';
import spell456 from '../../data/spells/skywrite.json';
import spell457 from '../../data/spells/sleep.json';
import spell458 from '../../data/spells/sleet-storm.json';
import spell459 from '../../data/spells/slow.json';
import spell460 from '../../data/spells/snare.json';
import spell461 from '../../data/spells/snillocs-snowball-storm.json';
import spell462 from '../../data/spells/soul-cage.json';
import spell463 from '../../data/spells/spare-the-dying.json';
import spell464 from '../../data/spells/speak-with-animals.json';
import spell465 from '../../data/spells/speak-with-dead.json';
import spell466 from '../../data/spells/speak-with-plants.json';
import spell467 from '../../data/spells/spider-climb.json';
import spell468 from '../../data/spells/spike-growth.json';
import spell469 from '../../data/spells/spirit-guardians.json';
import spell471 from '../../data/spells/spirit-of-death.json';
import spell470 from '../../data/spells/spirit-of-death-ua.json';
import spell472 from '../../data/spells/spirit-shroud.json';
import spell473 from '../../data/spells/spiritual-weapon.json';
import spell475 from '../../data/spells/spray-of-cards.json';
import spell474 from '../../data/spells/spray-of-cards-ua.json';
import spell476 from '../../data/spells/staggering-smite.json';
import spell477 from '../../data/spells/steel-wind-strike.json';
import spell478 from '../../data/spells/stinking-cloud.json';
import spell479 from '../../data/spells/stone-shape.json';
import spell480 from '../../data/spells/stoneskin.json';
import spell481 from '../../data/spells/storm-of-vengeance.json';
import spell482 from '../../data/spells/storm-sphere.json';
import spell483 from '../../data/spells/sudden-awakening.json';
import spell484 from '../../data/spells/suggestion.json';
import spell485 from '../../data/spells/summon-aberration.json';
import spell486 from '../../data/spells/summon-beast.json';
import spell487 from '../../data/spells/summon-celestial.json';
import spell488 from '../../data/spells/summon-construct.json';
import spell490 from '../../data/spells/summon-draconic-spirit.json';
import spell489 from '../../data/spells/summon-draconic-spirit-ua.json';
import spell491 from '../../data/spells/summon-elemental.json';
import spell492 from '../../data/spells/summon-fey.json';
import spell493 from '../../data/spells/summon-fiend.json';
import spell494 from '../../data/spells/summon-greater-demon.json';
import spell495 from '../../data/spells/summon-lesser-demons.json';
import spell496 from '../../data/spells/summon-shadowspawn.json';
import spell497 from '../../data/spells/summon-undead.json';
import spell498 from '../../data/spells/summon-warrior-spirit.json';
import spell499 from '../../data/spells/sunbeam.json';
import spell500 from '../../data/spells/sunburst.json';
import spell501 from '../../data/spells/swift-quiver.json';
import spell502 from '../../data/spells/sword-burst.json';
import spell503 from '../../data/spells/symbol.json';
import spell504 from '../../data/spells/synaptic-static.json';
import spell505 from '../../data/spells/synchronicity.json';
import spell506 from '../../data/spells/system-backdoor.json';
import spell507 from '../../data/spells/tashas-caustic-brew.json';
import spell508 from '../../data/spells/tashas-hideous-laughter.json';
import spell509 from '../../data/spells/tashas-mind-whip.json';
import spell510 from '../../data/spells/tashas-otherworldly-guise.json';
import spell511 from '../../data/spells/telekinesis.json';
import spell512 from '../../data/spells/telepathy.json';
import spell513 from '../../data/spells/teleport.json';
import spell514 from '../../data/spells/teleportation-circle.json';
import spell515 from '../../data/spells/temple-of-the-gods.json';
import spell516 from '../../data/spells/temporal-shunt.json';
import spell517 from '../../data/spells/tensers-floating-disk.json';
import spell518 from '../../data/spells/tensers-transformation.json';
import spell519 from '../../data/spells/tether-essence.json';
import spell520 from '../../data/spells/thaumaturgy.json';
import spell521 from '../../data/spells/thorn-whip.json';
import spell522 from '../../data/spells/thought-shield.json';
import spell523 from '../../data/spells/thunder-step.json';
import spell524 from '../../data/spells/thunderclap.json';
import spell525 from '../../data/spells/thunderous-smite.json';
import spell526 from '../../data/spells/thunderwave.json';
import spell527 from '../../data/spells/tidal-wave.json';
import spell528 from '../../data/spells/time-ravage.json';
import spell529 from '../../data/spells/time-stop.json';
import spell530 from '../../data/spells/tiny-servant.json';
import spell531 from '../../data/spells/toll-the-dead.json';
import spell532 from '../../data/spells/tongues.json';
import spell533 from '../../data/spells/transmute-rock.json';
import spell534 from '../../data/spells/transport-via-plants.json';
import spell535 from '../../data/spells/tree-stride.json';
import spell536 from '../../data/spells/true-polymorph.json';
import spell537 from '../../data/spells/true-resurrection.json';
import spell538 from '../../data/spells/true-seeing.json';
import spell539 from '../../data/spells/true-strike.json';
import spell540 from '../../data/spells/tsunami.json';
import spell541 from '../../data/spells/unearthly-chorus.json';
import spell542 from '../../data/spells/unseen-servant.json';
import spell543 from '../../data/spells/vampiric-touch.json';
import spell544 from '../../data/spells/vicious-mockery.json';
import spell545 from '../../data/spells/virtue.json';
import spell546 from '../../data/spells/vitriolic-sphere.json';
import spell547 from '../../data/spells/vortex-warp.json';
import spell548 from '../../data/spells/wall-of-fire.json';
import spell549 from '../../data/spells/wall-of-force.json';
import spell550 from '../../data/spells/wall-of-ice.json';
import spell551 from '../../data/spells/wall-of-light.json';
import spell552 from '../../data/spells/wall-of-sand.json';
import spell553 from '../../data/spells/wall-of-stone.json';
import spell554 from '../../data/spells/wall-of-thorns.json';
import spell555 from '../../data/spells/wall-of-water.json';
import spell556 from '../../data/spells/warding-bond.json';
import spell557 from '../../data/spells/warding-wind.json';
import spell558 from '../../data/spells/warp-sense.json';
import spell559 from '../../data/spells/water-breathing.json';
import spell560 from '../../data/spells/water-walk.json';
import spell561 from '../../data/spells/watery-sphere.json';
import spell562 from '../../data/spells/web.json';
import spell563 from '../../data/spells/weird.json';
import spell564 from '../../data/spells/whirlwind.json';
import spell565 from '../../data/spells/widogast-s-transmogrification-hb.json';
import spell566 from '../../data/spells/widogast-s-vault-of-amber-hb.json';
import spell567 from '../../data/spells/widogast-s-web-of-fire-hb.json';
import spell568 from '../../data/spells/wild-cunning.json';
import spell569 from '../../data/spells/wind-walk.json';
import spell570 from '../../data/spells/wind-wall.json';
import spell571 from '../../data/spells/wish.json';
import spell572 from '../../data/spells/witch-bolt.json';
import spell573 from '../../data/spells/wither-and-bloom.json';
import spell574 from '../../data/spells/word-of-radiance.json';
import spell575 from '../../data/spells/word-of-recall.json';
import spell576 from '../../data/spells/wrath-of-nature.json';
import spell577 from '../../data/spells/wrathful-smite.json';
import spell578 from '../../data/spells/wristpocket.json';
import spell579 from '../../data/spells/zephyr-strike.json';
import spell580 from '../../data/spells/zone-of-truth.json';
import type { Spell } from '../types';

export const spellDetails: Record<string, Spell.Details> = {
  'abi-dalzims-horrid-wilting': spell0,
  'absorb-elements': spell1,
  'acid-splash': spell2,
  'acid-stream': spell3,
  'aganazzars-scorcher': spell4,
  aid: spell5,
  'air-bubble': spell6,
  alarm: spell7,
  'alter-self': spell8,
  'animal-friendship': spell9,
  'animal-messenger': spell10,
  'animal-shapes': spell11,
  'animate-dead': spell12,
  'animate-objects': spell13,
  'antagonize-ua': spell14,
  antagonize: spell15,
  'antilife-shell': spell16,
  'antimagic-field': spell17,
  'antipathy-sympathy': spell18,
  'arcane-eye': spell19,
  'arcane-gate': spell20,
  'arcane-hacking': spell21,
  'arcane-lock': spell22,
  'arcane-weapon': spell23,
  'armor-of-agathys': spell24,
  'arms-of-hadar': spell25,
  'ashardalons-stride': spell26,
  'astral-projection': spell27,
  augury: spell28,
  'aura-of-life': spell29,
  'aura-of-purity': spell30,
  'aura-of-vitality': spell31,
  awaken: spell32,
  bane: spell33,
  'banishing-smite': spell34,
  banishment: spell35,
  barkskin: spell36,
  'beacon-of-hope': spell37,
  'beast-bond': spell38,
  'beast-sense': spell39,
  'bestow-curse': spell40,
  'bigbys-hand': spell41,
  'blade-barrier': spell42,
  'blade-of-disaster': spell43,
  'blade-ward': spell44,
  bless: spell45,
  blight: spell46,
  'blinding-smite': spell47,
  'blindness-deafness': spell48,
  blink: spell49,
  blur: spell50,
  'bones-of-the-earth': spell51,
  'booming-blade': spell52,
  'borrowed-knowledge': spell53,
  'branding-smite': spell54,
  'burning-hands': spell55,
  'call-lightning': spell56,
  'calm-emotions': spell57,
  catapult: spell58,
  catnap: spell59,
  'cause-fear': spell60,
  ceremony: spell61,
  'chain-lightning': spell62,
  'chaos-bolt': spell63,
  'charm-monster': spell64,
  'charm-person': spell65,
  'chill-touch': spell66,
  'chromatic-orb': spell67,
  'circle-of-death': spell68,
  'circle-of-power': spell69,
  clairvoyance: spell70,
  clone: spell71,
  'cloud-of-daggers': spell72,
  cloudkill: spell73,
  'color-spray': spell74,
  command: spell75,
  'commune-with-city': spell76,
  'commune-with-nature': spell77,
  commune: spell78,
  'compelled-duel': spell79,
  'comprehend-languages': spell80,
  compulsion: spell81,
  'cone-of-cold': spell82,
  confusion: spell83,
  'conjure-animals': spell84,
  'conjure-barlgura': spell85,
  'conjure-barrage': spell86,
  'conjure-celestial': spell87,
  'conjure-elemental': spell88,
  'conjure-fey': spell89,
  'conjure-hezrou': spell90,
  'conjure-knowbot': spell91,
  'conjure-lesser-demon': spell92,
  'conjure-minor-elementals': spell93,
  'conjure-shadow-demon': spell94,
  'conjure-volley': spell95,
  'conjure-vrock': spell96,
  'conjure-woodland-beings': spell97,
  'contact-other-plane': spell98,
  contagion: spell99,
  contingency: spell100,
  'continual-flame': spell101,
  'control-flames': spell102,
  'control-water': spell103,
  'control-weather': spell104,
  'control-winds': spell105,
  'cordon-of-arrows': spell106,
  counterspell: spell107,
  'create-bonfire': spell108,
  'create-food-and-water': spell109,
  'create-homunculus': spell110,
  'create-magen': spell111,
  'create-or-destroy-water': spell112,
  'create-spelljamming-helm': spell113,
  'create-undead': spell114,
  creation: spell115,
  'crown-of-madness': spell116,
  'crown-of-stars': spell117,
  'crusaders-mantle': spell118,
  'cure-wounds': spell119,
  'dancing-lights': spell120,
  'danse-macabre': spell121,
  'dark-star': spell122,
  darkness: spell123,
  darkvision: spell124,
  dawn: spell125,
  daylight: spell126,
  'death-ward': spell127,
  decompose: spell128,
  'delayed-blast-fireball': spell129,
  demiplane: spell130,
  'destructive-wave': spell131,
  'detect-evil-and-good': spell132,
  'detect-magic': spell133,
  'detect-poison-and-disease': spell134,
  'detect-thoughts': spell135,
  'digital-phantom': spell136,
  'dimension-door': spell137,
  'disguise-self': spell138,
  disintegrate: spell139,
  'dispel-evil-and-good': spell140,
  'dispel-magic': spell141,
  'dissonant-whispers': spell142,
  'distort-value': spell143,
  divination: spell144,
  'divine-favor': spell145,
  'divine-word': spell146,
  'dominate-beast': spell147,
  'dominate-monster': spell148,
  'dominate-person': spell149,
  'draconic-transformation-ua': spell150,
  'draconic-transformation': spell151,
  'dragons-breath': spell152,
  'drawmijs-instant-summons': spell153,
  'dream-of-the-blue-veil': spell154,
  dream: spell155,
  'druid-grove': spell156,
  druidcraft: spell157,
  'dust-devil': spell158,
  'earth-tremor': spell159,
  earthbind: spell160,
  earthquake: spell161,
  'ego-whip': spell162,
  'eldritch-blast': spell163,
  'elemental-bane': spell164,
  'elemental-weapon': spell165,
  'encode-thoughts': spell166,
  'enemies-abound': spell167,
  enervation: spell168,
  'enhance-ability': spell169,
  'enlarge-reduce': spell170,
  'ensnaring-strike': spell171,
  entangle: spell172,
  enthrall: spell173,
  'erupting-earth': spell174,
  etherealness: spell175,
  'evards-black-tentacles': spell176,
  'expeditious-retreat': spell177,
  eyebite: spell178,
  fabricate: spell179,
  'faerie-fire': spell180,
  'false-life': spell181,
  'far-step': spell182,
  'fast-friends': spell183,
  fear: spell184,
  'feather-fall': spell185,
  feeblemind: spell186,
  'feign-death': spell187,
  'find-familiar': spell188,
  'find-greater-steed': spell189,
  'find-steed': spell190,
  'find-the-path': spell191,
  'find-traps': spell192,
  'find-vehicle': spell193,
  'finger-of-death': spell194,
  'fire-bolt': spell195,
  'fire-shield': spell196,
  'fire-storm': spell197,
  fireball: spell198,
  'fizban-s-platinum-shield-ua': spell199,
  'fizbans-platinum-shield': spell200,
  'flame-arrows': spell201,
  'flame-blade': spell202,
  'flame-stride': spell203,
  'flame-strike': spell204,
  'flaming-sphere': spell205,
  'flesh-to-stone': spell206,
  'flock-of-familiars': spell207,
  fly: spell208,
  'fog-cloud': spell209,
  forbiddance: spell210,
  forcecage: spell211,
  foresight: spell212,
  'fortunes-favor': spell213,
  'freedom-of-movement': spell214,
  'freedom-of-the-waves': spell215,
  'freedom-of-the-winds': spell216,
  friends: spell217,
  'frost-fingers': spell218,
  frostbite: spell219,
  'galders-speedy-courier': spell220,
  'galders-tower': spell221,
  'gaseous-form': spell222,
  'gate-seal': spell223,
  gate: spell224,
  geas: spell225,
  'gentle-repose': spell226,
  'giant-insect': spell227,
  'gift-of-alacrity': spell228,
  'gift-of-gab': spell229,
  glibness: spell230,
  'globe-of-invulnerability': spell231,
  'glyph-of-warding': spell232,
  goodberry: spell233,
  'grasping-vine': spell234,
  'gravity-fissure': spell235,
  'gravity-sinkhole': spell236,
  grease: spell237,
  'greater-invisibility': spell238,
  'greater-restoration': spell239,
  'green-flame-blade': spell240,
  'guardian-of-faith': spell241,
  'guardian-of-nature': spell242,
  'guards-and-wards': spell243,
  guidance: spell244,
  'guiding-bolt': spell245,
  'guiding-hand-ua': spell246,
  'gust-of-wind': spell247,
  gust: spell248,
  'hail-of-thorns': spell249,
  hallow: spell250,
  'hallucinatory-terrain': spell251,
  'hand-of-radiance': spell252,
  harm: spell253,
  haste: spell254,
  haywire: spell255,
  heal: spell256,
  'healing-elixir-ua': spell257,
  'healing-spirit': spell258,
  'healing-word': spell259,
  'heat-metal': spell260,
  'hellish-rebuke': spell261,
  'heroes-feast': spell262,
  heroism: spell263,
  hex: spell264,
  'hold-monster': spell265,
  'hold-person': spell266,
  'holy-aura': spell267,
  'holy-weapon': spell268,
  'house-of-cards-ua': spell269,
  'hunger-of-hadar': spell270,
  'hunters-mark': spell271,
  'hypnotic-pattern': spell272,
  'ice-knife': spell273,
  'ice-storm': spell274,
  'icingdeath-s-frost': spell275,
  'id-insinuation': spell276,
  identify: spell277,
  'illusory-dragon': spell278,
  'illusory-script': spell279,
  immolation: spell280,
  'immovable-object': spell281,
  imprisonment: spell282,
  'incendiary-cloud': spell283,
  'incite-greed': spell284,
  'infallible-relay': spell285,
  'infernal-calling': spell286,
  infestation: spell287,
  'inflict-wounds': spell288,
  'insect-plague': spell289,
  'intellect-fortress': spell290,
  'investiture-of-flame': spell291,
  'investiture-of-ice': spell292,
  'investiture-of-stone': spell293,
  'investiture-of-wind': spell294,
  'invisibility-to-cameras': spell295,
  invisibility: spell296,
  invulnerability: spell297,
  'jims-glowing-coin': spell298,
  'jims-magic-missile': spell299,
  jump: spell300,
  'kinetic-jaunt': spell301,
  knock: spell302,
  'legend-lore': spell303,
  'leomunds-secret-chest': spell304,
  'leomunds-tiny-hut': spell305,
  'lesser-restoration': spell306,
  levitate: spell307,
  'life-transference': spell308,
  light: spell309,
  'lightning-arrow': spell310,
  'lightning-bolt': spell311,
  'lightning-lure': spell312,
  'locate-animals-or-plants': spell313,
  'locate-creature': spell314,
  'locate-object': spell315,
  longstrider: spell316,
  'maddening-darkness': spell317,
  maelstrom: spell318,
  'mage-armor': spell319,
  'mage-hand-legerdomain': spell320,
  'mage-hand': spell321,
  'magic-circle': spell322,
  'magic-jar': spell323,
  'magic-missile': spell324,
  'magic-mouth': spell325,
  'magic-stone': spell326,
  'magic-weapon': spell327,
  'magnify-gravity': spell328,
  'major-image': spell329,
  'mass-cure-wounds': spell330,
  'mass-heal': spell331,
  'mass-healing-word': spell332,
  'mass-polymorph': spell333,
  'mass-suggestion': spell334,
  'maximillians-earthen-grasp': spell335,
  maze: spell336,
  'meld-into-stone': spell337,
  'melfs-acid-arrow': spell338,
  'melfs-minute-meteors': spell339,
  mending: spell340,
  'mental-barrier': spell341,
  'mental-prison': spell342,
  message: spell343,
  'meteor-swarm': spell344,
  'mighty-fortress': spell345,
  'mind-blank': spell346,
  'mind-sliver': spell347,
  'mind-spike': spell348,
  'mind-thrust': spell349,
  'minor-illusion': spell350,
  'mirage-arcane': spell351,
  'mirror-image': spell352,
  mislead: spell353,
  'misty-step': spell354,
  'modify-memory': spell355,
  'mold-earth': spell356,
  moonbeam: spell357,
  'mordenkainens-faithful-hound': spell358,
  'mordenkainens-magnificent-mansion': spell359,
  'mordenkainens-private-sanctum': spell360,
  'mordenkainens-sword': spell361,
  'motivational-speech': spell362,
  'move-earth': spell363,
  'nathairs-mischief-ua': spell364,
  'nathairs-mischief': spell365,
  'negative-energy-flood': spell366,
  nondetection: spell367,
  'nystuls-magic-aura': spell368,
  'on-off': spell369,
  'otherworldly-form': spell370,
  'otilukes-freezing-sphere': spell371,
  'otilukes-resilient-sphere': spell372,
  'ottos-irresistible-dance': spell373,
  'pass-without-trace': spell374,
  passwall: spell375,
  'phantasmal-force': spell376,
  'phantasmal-killer': spell377,
  'phantom-steed': spell378,
  'planar-ally': spell379,
  'planar-binding': spell380,
  'plane-shift': spell381,
  'plant-growth': spell382,
  'poison-spray': spell383,
  polymorph: spell384,
  'power-word-heal': spell385,
  'power-word-kill': spell386,
  'power-word-pain': spell387,
  'power-word-stun': spell388,
  'prayer-of-healing': spell389,
  prestidigitation: spell390,
  'primal-savagery': spell391,
  'primordial-ward': spell392,
  'prismatic-spray': spell393,
  'prismatic-wall': spell394,
  'produce-flame': spell395,
  'programmed-illusion': spell396,
  'project-image': spell397,
  'protection-from-ballistics': spell398,
  'protection-from-energy': spell399,
  'protection-from-evil-and-good': spell400,
  'protection-from-poison': spell401,
  'psionic-blast': spell402,
  'psychic-crush': spell403,
  'psychic-scream': spell404,
  'pulse-wave': spell405,
  puppet: spell406,
  'purify-food-and-drink': spell407,
  pyrotechnics: spell408,
  'raise-dead': spell409,
  'rarys-telepathic-bond': spell410,
  'raulothims-psychic-lance-ua': spell411,
  'raulothims-psychic-lance': spell412,
  'ravenous-void': spell413,
  'ray-of-enfeeblement': spell414,
  'ray-of-frost': spell415,
  'ray-of-sickness': spell416,
  'reality-break': spell417,
  regenerate: spell418,
  reincarnate: spell419,
  'remote-access': spell420,
  'remove-curse': spell421,
  resistance: spell422,
  resurrection: spell423,
  'reverse-gravity': spell424,
  revivify: spell425,
  'rimes-binding-ice': spell426,
  'rope-trick': spell427,
  'sacred-flame': spell428,
  sanctuary: spell429,
  'sapping-sting': spell430,
  scatter: spell431,
  'scorching-ray': spell432,
  scrying: spell433,
  'searing-smite': spell434,
  'see-invisibility': spell435,
  seeming: spell436,
  sending: spell437,
  'sense-emotion': spell438,
  sequester: spell439,
  'shadow-blade': spell440,
  'shadow-of-moil': spell441,
  'shape-water': spell442,
  shapechange: spell443,
  shatter: spell444,
  'shield-of-faith': spell445,
  shield: spell446,
  shillelagh: spell447,
  'shocking-grasp': spell448,
  shutdown: spell449,
  'sickening-radiance': spell450,
  silence: spell451,
  'silent-image': spell452,
  'silvery-barbs': spell453,
  simulacrum: spell454,
  'skill-empowerment': spell455,
  skywrite: spell456,
  sleep: spell457,
  'sleet-storm': spell458,
  slow: spell459,
  snare: spell460,
  'snillocs-snowball-storm': spell461,
  'soul-cage': spell462,
  'spare-the-dying': spell463,
  'speak-with-animals': spell464,
  'speak-with-dead': spell465,
  'speak-with-plants': spell466,
  'spider-climb': spell467,
  'spike-growth': spell468,
  'spirit-guardians': spell469,
  'spirit-of-death-ua': spell470,
  'spirit-of-death': spell471,
  'spirit-shroud': spell472,
  'spiritual-weapon': spell473,
  'spray-of-cards-ua': spell474,
  'spray-of-cards': spell475,
  'staggering-smite': spell476,
  'steel-wind-strike': spell477,
  'stinking-cloud': spell478,
  'stone-shape': spell479,
  stoneskin: spell480,
  'storm-of-vengeance': spell481,
  'storm-sphere': spell482,
  'sudden-awakening': spell483,
  suggestion: spell484,
  'summon-aberration': spell485,
  'summon-beast': spell486,
  'summon-celestial': spell487,
  'summon-construct': spell488,
  'summon-draconic-spirit-ua': spell489,
  'summon-draconic-spirit': spell490,
  'summon-elemental': spell491,
  'summon-fey': spell492,
  'summon-fiend': spell493,
  'summon-greater-demon': spell494,
  'summon-lesser-demons': spell495,
  'summon-shadowspawn': spell496,
  'summon-undead': spell497,
  'summon-warrior-spirit': spell498,
  sunbeam: spell499,
  sunburst: spell500,
  'swift-quiver': spell501,
  'sword-burst': spell502,
  symbol: spell503,
  'synaptic-static': spell504,
  synchronicity: spell505,
  'system-backdoor': spell506,
  'tashas-caustic-brew': spell507,
  'tashas-hideous-laughter': spell508,
  'tashas-mind-whip': spell509,
  'tashas-otherworldly-guise': spell510,
  telekinesis: spell511,
  telepathy: spell512,
  teleport: spell513,
  'teleportation-circle': spell514,
  'temple-of-the-gods': spell515,
  'temporal-shunt': spell516,
  'tensers-floating-disk': spell517,
  'tensers-transformation': spell518,
  'tether-essence': spell519,
  thaumaturgy: spell520,
  'thorn-whip': spell521,
  'thought-shield': spell522,
  'thunder-step': spell523,
  thunderclap: spell524,
  'thunderous-smite': spell525,
  thunderwave: spell526,
  'tidal-wave': spell527,
  'time-ravage': spell528,
  'time-stop': spell529,
  'tiny-servant': spell530,
  'toll-the-dead': spell531,
  tongues: spell532,
  'transmute-rock': spell533,
  'transport-via-plants': spell534,
  'tree-stride': spell535,
  'true-polymorph': spell536,
  'true-resurrection': spell537,
  'true-seeing': spell538,
  'true-strike': spell539,
  tsunami: spell540,
  'unearthly-chorus': spell541,
  'unseen-servant': spell542,
  'vampiric-touch': spell543,
  'vicious-mockery': spell544,
  virtue: spell545,
  'vitriolic-sphere': spell546,
  'vortex-warp': spell547,
  'wall-of-fire': spell548,
  'wall-of-force': spell549,
  'wall-of-ice': spell550,
  'wall-of-light': spell551,
  'wall-of-sand': spell552,
  'wall-of-stone': spell553,
  'wall-of-thorns': spell554,
  'wall-of-water': spell555,
  'warding-bond': spell556,
  'warding-wind': spell557,
  'warp-sense': spell558,
  'water-breathing': spell559,
  'water-walk': spell560,
  'watery-sphere': spell561,
  web: spell562,
  weird: spell563,
  whirlwind: spell564,
  'widogast-s-transmogrification-hb': spell565,
  'widogast-s-vault-of-amber-hb': spell566,
  'widogast-s-web-of-fire-hb': spell567,
  'wild-cunning': spell568,
  'wind-walk': spell569,
  'wind-wall': spell570,
  wish: spell571,
  'witch-bolt': spell572,
  'wither-and-bloom': spell573,
  'word-of-radiance': spell574,
  'word-of-recall': spell575,
  'wrath-of-nature': spell576,
  'wrathful-smite': spell577,
  wristpocket: spell578,
  'zephyr-strike': spell579,
  'zone-of-truth': spell580,
};
